import { useState } from "react";
import { api } from "@/lib/api";
import { ReadAloudButton } from "@/components/ReadAloudButton";
import { toast } from "sonner";
import { Mic } from "lucide-react";

const VOICES = [
  { key: "fable", label: "Fable — warm storyteller" },
  { key: "nova", label: "Nova — bright & friendly" },
  { key: "shimmer", label: "Shimmer — gentle & calm" },
  { key: "echo", label: "Echo — clear & steady" },
  { key: "onyx", label: "Onyx — deep & rich" },
  { key: "alloy", label: "Alloy — neutral & even" },
  { key: "sage", label: "Sage — soft & thoughtful" },
];

export function VoicePicker() {
  const [voice, setVoice] = useState(localStorage.getItem("rfa_voice") || "fable");

  const change = async (v) => {
    setVoice(v);
    localStorage.setItem("rfa_voice", v);
    try { await api.put("/me/voice", { voice: v }); toast.success("Narrator voice saved!"); }
    catch { toast.error("Saved on this device, but couldn't sync to your account."); }
  };

  return (
    <div className="rounded-2xl bg-white border border-[#EAE6DF] p-5">
      <p className="font-head font-semibold text-[#3D405B] flex items-center gap-2 mb-3"><Mic size={16} className="text-[#81B29A]" /> Narrator voice</p>
      <div className="flex flex-wrap items-center gap-3">
        <select data-testid="voice-select" value={voice} onChange={(e) => change(e.target.value)}
          className="flex-1 min-w-[200px] rounded-xl border border-[#EAE6DF] px-4 py-2.5 outline-none focus:ring-2 focus:ring-[#81B29A]">
          {VOICES.map((v) => <option key={v.key} value={v.key}>{v.label}</option>)}
        </select>
        <ReadAloudButton key={voice} testid="voice-preview" label="Preview voice" voice={voice}
          text="Hello! I'll be your reading helper. Let's learn something wonderful today." />
      </div>
    </div>
  );
}
